export const KYC_STATUSES = {
    KYC_STARTED: 'kyc_started',
    KYC_NOT_STARTED: 'kyc_not_started',
    KYC_CONSIDER: 'kyc_consider',
    KYC_DECLINED: 'kyc_declined',
    KYC_RETRY: 'kyc_retry',
    KYC_COMPLETED: 'kyc_completed',
} as const;

export type KycStatusKey = keyof typeof KYC_STATUSES;
export type KycStatusValue = (typeof KYC_STATUSES)[KycStatusKey];

export const { KYC_STARTED, KYC_NOT_STARTED, KYC_CONSIDER, KYC_DECLINED, KYC_RETRY, KYC_COMPLETED } = KYC_STATUSES;
